<template>
    <base-lined-card
        class="blog-slide-card"
        :to="to"
        :image="thumbnail"
        :title="title"
    />
</template>

<script>
    import BaseLinedCard from '../BaseLinedCard/BaseLinedCard';

    export default {
        name: 'blog-slide-card',

        components: { BaseLinedCard },

        props: {
            thumbnail: {
                type: Object,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            to: {
                type: String,
                required: true,
            },
        },
    };
</script>
